var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VCard',{staticClass:"flex h-full dark:bg-gray-700",on:{"click":function($event){return _vm.openSubcategory(_vm.item.id)}}},[_c('VCardTitle',{staticClass:"word-wrap"},[_vm._v(_vm._s(_vm.item.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }